<template>
    <div class="page-container">
        <div class="incentive-block">
            <div class="incentive-item">
                <div class="incentive-count">{{pageData.saleRelease}} 瓶</div>
                <div class="incentive-text"><van-icon @click="showToast" name="info" size="12" color="#FFD309" /> 待释放销售奖励</div>
            </div>
            <div class="incentive-item">
                <div class="incentive-count">{{pageData.saleTotal}} 瓶</div>
                <div class="incentive-text">已获销售奖励</div>
            </div>
        </div>
        <div class="page-wrapper">
            <!-- 我的奖励记录 -->
            <div class="incentive-title">
                <span>我的奖励记录</span>
                <!-- <van-popover
                    v-model="showPopover"
                    theme="dark"
                    trigger="click"
                    placement="bottom-end"
                    :actions="actions"
                    @select="onSelect"
                >
                    <template #reference>
                        <van-icon name="filter-o" size="22" color="#666"/>
                    </template>
                </van-popover> -->
                <van-icon name="filter-o" @click="showPopover = !showPopover" size="22" color="#666"/>
                <div class="pop-box" v-show="showPopover">
                    <div class="pop-item" @click="onSelect(0)">全部</div>
                    <div class="pop-item" v-for="(item,index) in goodsList" :key="index" @click="onSelect(item.name)">{{item.name}}</div>
                </div>
            </div>
            <div class="num-detail">
                <span>已获取：{{pageData.saleTotal}}瓶</span>
                <span>待释放：{{pageData.saleRelease}}瓶</span>
            </div>
            <!-- 列表 -->
            <div class="incentive-list">
                <div class="incentive-item" v-for="(item,index) in list" :key="index" @click="jumpPage('purchase-detail',item.orderId,item.status)">
                    <div class="item-top">
                        <span class="date">{{item.createTime | formatCreatetime}}</span>
                        <span class="status waiting">{{item.status == 1 ? '待释放' : '已释放'}}</span>
                    </div>
                    <div class="item-bottom">
                        <img :src="item.picUrl" alt="" class="goods-pic">
                        <div class="goods-info">
                            <div class="name-price">
                                <div class="name">{{`${item.name} ${item.degree}度 ${item.capacity}`}}</div>
                                <!-- <div class="price">￥{{item.amount}}</div> -->
                            </div>
                            <div class="sku-num">
                                <span class="sku">{{item.unit == '箱' ? '整箱(6瓶)' : '单瓶'}}</span>
                                <span class="num">{{item.num}}{{item.unit == '箱' ? '箱' : '瓶'}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 数据为空 -->
            <van-empty v-show="list.length == 0" :image=nullImg description="暂无数据~" />
        </div>
        <!-- <div class="bottom-links">
            <router-link to="/reward/rules" class="link-item">奖励政策</router-link>
        </div> -->
    </div>
</template>
<script>
import { Icon,Popover,Toast,Empty } from 'vant'
import $http from '@/lib/request'
import config from '@/config'

export default {
    data() {
        return {
            showPopover: false,
            actions: [],
            pageData:{},
            list:[],
            goodId:0,
            nullImg:require('@/assets/icon-null.png'),
            goodsList:[],
        };
    },
    components:{
        [Icon.name]:Icon,
        [Popover.name]:Popover,
        [Toast.name]:Toast,
        [Empty.name]:Empty
    },
    activated(){
        this.getData();
    },
    deactivated(){
        this.showPopover=false;
    },
    methods:{
        onSelect(action) {
            // this.goodId=action.id;
            this.goodId=action;
            this.showPopover=false;
            this.list=[];
            this.getData();
        },
        showToast(){
            Toast('待释放的商品在下次补货时释放');
        },
        getData(){
            $http({
                method:'post',
                data:{
                    goodId:this.goodId
                },
                url:config.api.salesIncentive
            }).then(res=>{
                if(res.errno == 0){
                    // let tmp=res.data.goodsList;
                    // let tmparr=[{text:'全部',id:0}];
                    // for(let i=0;i<tmp.length;i++){
                    //     tmparr.push({
                    //         text:tmp[i].name,
                    //         id:tmp[i].id
                    //     });
                    // }
                    // this.actions=tmparr;
                    this.goodsList=res.data.goodsList;

                    this.pageData=res.data;
                    this.list=res.data.rewardList;
                }else{
                    Toast(res.errmsg);
                }
            })
        },
        jumpPage(name,oid,status){
            this.$router.push({
                name:name,
                params:{
                    orderId:oid,
                    status:status,
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
::v-deep .van-empty__image{
    width:140px;
    height:108px;
}
::v-deep .van-empty{
    margin-top: 50px;
}
button{
    height:40px;
    line-height: 40px;
}
.van-popover_action{
    font-size: 100px;
}

.page-container{
    .incentive-block{
        height:85px;
        background: linear-gradient(180deg, #3CA7FE 0%, #3088F5 100%);
        @include flex-between();
        .incentive-item{
            width: 50%;
            text-align: center;
            color:#fff;
            position: relative;
            &:first-child{
                &::after{
                    content:'';
                    display: block;
                    height:40px;
                    background:rgba(255,255,255,0.6);
                    width:1px;
                    position: absolute;
                    right:0;
                    top:50%;
                    transform: translateY(-50%);
                }
            }
            .incentive-count{
                font-size: 20px;
                line-height: 24px;
                font-family: DINAlternate-Bold, DINAlternate;
                font-weight: bold;
                margin-bottom: 5px;
            }
            .incentive-text{
                font-size: 14px;
                line-height: 20px;
                color:rgba(255,255,255,0.7);
            }
        }
    }
    .page-wrapper{
        padding:10px;
        padding-bottom: 100px;
        background:#f5f5f5;
        min-height: calc(100vh - 85px);
        box-sizing: border-box;
        .incentive-title{
            font-size: 16px;
            color:#333;
            line-height: 22px;
            @include flex-between();
            margin-bottom: 16px;
            position: relative;
            .pop-box{
                position: absolute;
                right:0;
                top:35px;
                background:rgba(0,0,0,0.7);
                border-radius: 4px;
                text-align: center;
                &::after{
                    content: '';
                    width: 0;
                    height: 0;
                    border-style: solid;
                    border-width: 0 5px 8.7px 5px;
                    border-color: transparent transparent rgba(0,0,0,0.7) transparent;
                    position: absolute;
                    right:5px;
                    top:-8.7px;
                }
                .pop-item{
                    height:40px;
                    line-height: 40px;
                    border-bottom: 1px solid rgba(255,255,255,0.2);
                    padding:0 25px;
                    font-size: 13px;
                    color:#fff;
                }
            }
        }
        .num-detail{
            font-size: 14px;
            color:#666;
            line-height: 20px;
            &>span{
                margin-right: 20px;
            }
        }
        .incentive-list{
            margin-top: 10px;
            .incentive-item{
                background:#fff;
                border-radius: 4px;
                padding:0 15px;
                margin-bottom: 10px;
                .item-top{
                    @include flex-between();
                    height:44px;
                    line-height: 44px;
                    color:#999;
                    border-bottom: 1px solid #f5f5f5;
                    .date{
                        font-size: 13px;
                    }
                    .status{
                        font-size: 14px;
                        &.waiting{
                            color:#FFA820;
                        }
                    }
                }
                .item-bottom{
                    padding:15px 0;
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    .goods-pic{
                        width:70px;
                        height:70px;
                        border-radius: 4px;
                    }
                    .goods-info{
                        width:255px;
                        .name-price{
                            @include flex-between();
                            font-size: 14px;
                            color:#000;
                            margin-bottom: 10px;
                            .name{
                                max-width: 180px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                            .price{

                            }
                        }
                        .sku-num{
                            @include flex-between();
                            .sku{
                                font-size: 12px;
                                color:#999;
                            }
                            .num{
                                font-size: 13px;
                                color:#3088F5;
                            }
                        }
                    }
                }
            }
        }
    }
    .bottom-links{
        width:100vw;
        position: fixed;
        left: 0;
        bottom: 0;
        text-align: center;
        padding-bottom: 10px;
        .link-item{
            font-size: 14px;
            color:#3088F5;
            line-height: 20px;
        }
    }
}
</style>